import { useEffect } from 'react';

export function useSelectionsListener(onSelection) {
    useEffect(() => {
        const handleButtonClick = (e) => {
            const button = e.target.closest('[data-elite-selections]');
            if (!button) return;

            const productId = button.getAttribute('data-elite-selections-id');
            const productName = button.getAttribute('data-elite-selections-name');
            const productImage = button.getAttribute('data-elite-selections-image');
            const productLink = button.getAttribute('data-elite-selections-link');

            if (!productId) return;

            onSelection({
                id: productId,
                name: productName || 'Unnamed Product',
                image: productImage || '',
                link: productLink || '',
            });
        };

        document.addEventListener('click', handleButtonClick);
        return () => document.removeEventListener('click', handleButtonClick);
    }, [onSelection]);
}
